import { render, staticRenderFns } from "./draftProductShopee.vue?vue&type=template&id=36a55f0f&scoped=true"
import script from "./draftProductShopee.vue?vue&type=script&lang=js"
export * from "./draftProductShopee.vue?vue&type=script&lang=js"
import style0 from "./draftProductShopee.vue?vue&type=style&index=0&id=36a55f0f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36a55f0f",
  null
  
)

export default component.exports